
export const sampleUsers = [
    {
        email: "sachikanta@aaysinsight.com",
        role: "Member",
        userGroup: ["CRM" ],
    },
    {
        email: "sanchit.kumar@aaysinsight.com",
        role: "Admin",
        userGroup: ["Marketing" ],
    },
    {
        email: "nabasundar.rout@aaysinsight.com",
        role: "Member",
        userGroup: ["CRM" ],
    },
    {
        email: "sumit.trew@aaysinsight.com",
        role: "Member",
        userGroup: [" Sales"],
    },
    {
        email: "staquel@blaze.com",
        role: "Member",
        userGroup: ["Marketing"],
    },
    {
        email: "laguna@gnc.com",
        role: "Member",
        userGroup: ["Marketing"],
    },
    {
        email: "fernanda.bronzatto@royal.com",
        role: "Member",
        userGroup: ["Sales"],
    },
    {
        email: "emilie.sta@gngs.com",
        role: "Member",
        userGroup: ["Sales"],
    },
];
export const sampleGroupTypes = ["CRM", "Marketing", "Sales"];

export const tabs = ["USER MANAGEMENT", "USER REGISTRATION"];
export const Categorytabs = ["CATAGORY MANAGEMENT", "CATAGORY REGISTRATION"];
export const toolstabs = [
    "TOOL MANAGEMENT",
    "TOOL REGISTRATION",
    "TOOL APPROVAL",
    "TAG MANAGEMENT",
    "TAG REGISTRATIONS"
];